import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
} from "react-bootstrap";
import { FaEye, FaTrash, FaMapMarkerAlt } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import axios from "axios";

const OdList = () => {
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(""); // ✅ start date
  const [toDate, setToDate] = useState("");     // ✅ end date

  const [odList, setOdList] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleDelete = (od_id) => {
    // setOdList(odList.filter((item) => item.od_id !== id));
    axios.post(`${API_BASE_URL}od_delete.php`, { od_id: od_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);
          window.location.reload();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  };

  useEffect(() => {
      axios.post(`${API_BASE_URL}od_list.php`)
        .then((response) => {
          if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
            setOdList(response.data.body);
            // setFilteredOrders(response.data.body);
  
          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            setOdList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          setOdList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }, []);

    const parseDateDMY = (value) => {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
  const sep = value.includes("-") ? "-" : value.includes("/") ? "/" : null;
  if (sep) {
    const parts = value.split(sep);
    if (parts.length === 3 && parts[2].length === 4) {
      const d = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const y = parseInt(parts[2], 10);
      const dt = new Date(y, m, d);
      return isNaN(dt) ? null : dt;
    }
  }
  const dt = new Date(value);
  return isNaN(dt) ? null : dt;
};

  // ✅ filter function: search + date range
  const filteredOdList = odList.filter((item) => {
    const q = search.toLowerCase();
    const locStr = `${item.latitude},${item.longitude}`;

    const matchesSearch =
      !search ||
      (item.od_name && item.od_name.toLowerCase().includes(q)) ||
      (item.description && item.description.toLowerCase().includes(q)) ||
      (item.assigned_to_name && item.assigned_to_name.toLowerCase().includes(q)) ||
      (item.assigned_by_name && item.assigned_by_name.toLowerCase().includes(q)) ||
      (item.priority && item.priority.toLowerCase().includes(q)) ||
      (item.due_date && item.due_date.toLowerCase().includes(q)) ||
      (item.status && item.status.toLowerCase().includes(q)) ||
      locStr.toLowerCase().includes(q) ||
      String(item.od_id).includes(q);

    // const matchesDate =
    //   (!fromDate || new Date(item.due_date) >= new Date(fromDate)) &&
    //   (!toDate || new Date(item.due_date) <= new Date(toDate));
    if (fromDate || toDate) {
      const reqDate = parseDateDMY(item.due_date);
      if (!reqDate) return false;
      if (fromDate) {
        const from = new Date(fromDate + "T00:00:00");
        if (reqDate < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate + "T23:59:59");
        if (reqDate > to) return false;
      }
    }

    // return matchesSearch && matchesDate;
    return true;
  });

  // ✅ Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    indexOfFirstItem,
  } = usePagination(filteredOdList, 25); // show 5 OD items per page

  return (
    <Container fluid className="my-4 outer-container">
      <h2 className="text-center">OD Status</h2>
      {/* {currentItems.length === 0 && (
        <Container fluid className="outer-container my-4">
          <Row>
            <Col>
              <div className="not-found-box">Loading...</div>
            </Col>
          </Row>
        </Container>
      )} */}
      <Row className="mb-3">
        <Col md={4} className="mb-2">
          <Form.Label>Search</Form.Label>
          <Form.Control
            placeholder="Search by Title, status..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col md={3} className="mb-2">
          <Form.Label>From</Form.Label>
          <Form.Control
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            placeholder="From Date"
          />
        </Col>

        <Col md={3} className="mb-2">
          <Form.Label>To</Form.Label>
          <Form.Control
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            placeholder="To Date"
          />
        </Col>

        <Col md={2} className="d-flex mt-4">
          <Button
            className="btn-top"
            onClick={() => {
              setSearch("");
              setFromDate("");
              setToDate("");
            }}
          >
            Clear Filters
          </Button>
        </Col>
      </Row>


      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped my-3 customer-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>OD Date</th>
                <th>Title</th>
                <th>Assigned To</th>
                {/* <th>Assigned By</th> */}
                <th>Status</th>
                <th>Location</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, i) => (
                <tr key={item.od_id}>
                  {/* <td>{indexOfFirstItem + i + 1}</td> */}
                  <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                  <td>{item.due_date}</td>
                  <td>{item.od_name}</td>
                  <td>{item.assigned_to_name}</td>
                  {/* <td>{item.assigned_by_name}</td> */}
                  <td>{item.status}</td>
                  <td className="text-center">
                    {item.latitude !== "" && item.longitude !== "" ? (
                      <a
                        href={`https://www.google.com/maps?q=${item.latitude},${item.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        od_name={`View ${item.od_name} on map`}
                      >
                        <FaMapMarkerAlt className="map-icon" />
                      </a>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </td>
                  <td>
                    <Link to={`/viewod/${item.od_id}`}>
                      <FaEye className="view-icon me-3" />
                    </Link>{" "}
                    <FaTrash
                      className="delete-icon"
                      // onClick={() => handleDelete(item.od_id)}
                      onClick={() => {
                      if (window.confirm("Are you sure you want to delete this?")) {
                        handleDelete(item.od_id);
                      }
                    }}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))}

              {currentItems.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center">
                    No OD assignments found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* ✅ Pagination Component */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default OdList;
